/**
 * Returns the correct domain by hostname. If the hostname is localhost or 127.0.0.1, returns undefined.
 * If the hostname has more parts than topDomainPartsCount, returns the last topDomainPartsCount parts of the hostname.
 * Otherwise, returns the defaultDomain.
 *
 * @param context - The request context with the headers object.
 * @param defaultDomain - The default domain to be used in the cookie.
 * @param topDomainPartsCount - The number of parts to be taken from the end of the hostname. Defaults to the number of parts in the defaultDomain.
 * @returns The correct domain or undefined if the hostname is localhost or 127.0.0.1.
 */
export const getTopLevelDomain = (host?: string, defaultDomain?: string, topDomainPartsCount = defaultDomain?.split('.').length ?? 2) => {
  if (!host) return defaultDomain;

  const [hostname] = host.split(':');
  const parts = hostname.split('.');

  if (hostname === 'localhost' || hostname === '127.0.0.1') return undefined;

  return parts.length >= topDomainPartsCount ? parts.slice(-topDomainPartsCount).join('.') : defaultDomain;
};
